import React, { Component } from 'react';
import css from './VideoCallDrawer.css';
import { connect } from 'react-redux';
import { answer, rejectCall } from '../../../custom-ducks/webrtc.duck';
import { faPhone, faPhoneSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CallAnimation from './call_animation.gif';

// The actual video call now runs entirely in a separate standalone app
// ("Viveka Meet", live at live.viveka.world) -- webrtc.duck.js's offer()/
// answer() thunks open it in a new tab once the invite is sent/answered.
// This component's only remaining job is the real-time incoming-call
// popup: notify the other participant live (from anywhere in the app --
// see the mount point at src/app.js) and let them accept/reject, exactly
// as it always has.
class VideoCallDrawer extends Component {
  render() {
    const { callIncoming, onAnswer, onReject } = this.props;
    if (!callIncoming) return null;

    return (
      <div className={css.call_incoming}>
        <div className={css.call_action}>
          <span style={{ marginTop: '20px' }}>Incoming call from {callIncoming.name}</span>
          <img alt="call animation" className={css.call_animation} src={CallAnimation} />
          <div className={css.call_actions}>
            <div onClick={() => onReject(callIncoming.id)} className={css.cancel_call_action}>
              <FontAwesomeIcon icon={faPhoneSlash} />
            </div>
            <div onClick={() => onAnswer(callIncoming.id)} className={css.accept_call_action}>
              <FontAwesomeIcon icon={faPhone} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { callIncoming } = state.webrtc;
  return { callIncoming };
};

const mapDispatchToProps = dispatch => ({
  onAnswer: remoteUUID => dispatch(answer(remoteUUID)),
  onReject: remoteUUID => dispatch(rejectCall(remoteUUID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoCallDrawer);
